export const SEED_IDS = {
  metrics: {
    weight: 'd8ba540f-2e83-4fcc-905b-b85d04f7eb4c',
    water: '7757ae17-1606-4956-b7f0-aaf384fea553',
    mood: '3ef9b172-2b9e-4040-94d4-4061375c7cd3',
    journal: 'a1c4e8f2-6b3d-4a9e-8f1c-2d5e7b9a0c3f',
  },
} as const;
